import {client} from './services/client'

export  const quartiers = {
    namespaced:true,
    state:{
        quartiers:[],
    },
    mutations: {
        SET_QUARTIER (state,quartiers){
            state.quartiers = quartiers
        },

    },
    actions: {
        getQuartier({commit}){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/quartier/get',
                })
                    .then((response)=>{
                        let quartiers = response.data.quartiers;
                        console.log(quartiers);
                        commit('SET_QUARTIER',quartiers)

                    })
                    .catch((error)=>{
                        reject(error);
                    })
            })

        },

        setQuartier({commit},data){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/quartier/save',
                    data:data,
                })
                    .then((response)=>{
                        let quartiers = response.data.quartiers;
                        commit('SET_QUARTIER',quartiers);

                        resolve(response);
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            });
        },
        deleteQuartier({commit},id){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/quartier/delete/'+id,
                })
                    .then((response)=>{
                        let quartiers = response.data.quartiers;
                        commit('SET_QUARTIER',quartiers);
                    })
                    .catch((error)=>{
                        reject(error)
                    })
            })
        },
    },
    getters: {
        getQuartier: state  => {
            return state.quartiers
        },
    }
};
